import {
  FindTheLetterInterface,
  FindTheObjectInterface,
  AnimationType,
} from '../providers/GameProvider/types';

export const getAnimationForPage = (
  currentData: (FindTheLetterInterface | FindTheObjectInterface)[],
  onePageBehaviour: boolean
): AnimationType | undefined => {
  const currentPageAnimation = currentData?.[0].animation;
  const nextPageAnimation = onePageBehaviour ? currentData?.[1]?.animation : undefined;

  return currentPageAnimation || nextPageAnimation;
};
